var  $body, $modal, $secondaryModal, $window,sidebar_pos, sidebar_width,ajax_contents,scroll_from_top,menu_scroll;
var timeout = false;
var rtime;
var delta = 500;
var animations = {};

$(window).load(function () {
	"use strict";
	
	$body = $('body');
	$window = $(window);
	
	setTimeout(function () {
		$('#content_wrapper').removeClass("loading");
		$('#content_wrapper').addClass('loaded');
		$('#content_wrapper #main_wrapper').animate({
			opacity: 1
		}, 300);
				
		if($('.section').length>0){
		
			var anchors = [];
			var section_names = [];

			$('section').each(function(){
				anchors.push($(this).data('anchor'));
				section_names.push($(this).data('label'));
				if($(this).data('nav')){				
					$('.top-menu .nav-right').append('<div class="menu-item pull-left"><a href="#'+$(this).data('anchor')+'">'+$(this).data('label')+'</a></div>');
					$('.responsive-nav ul').append('<li class="menu-item"><a href="#'+$(this).data('anchor')+'">'+$(this).data('label')+'</a></li>');
				}
			}); 

			
			$('#fullpage').fullpage({
				anchors: anchors,
				scrollOverflow:true,
				scrollOverflowOptions: {
					probeType: 3
				},
				fitToSection: false,
				navigation: true,
				navigationPosition: 'right',
				navigationTooltips: section_names,

				afterLoad: function(anchorLink, index) {
					
					var loadedSection = $(this);
					var trigger = loadedSection.find('.fp-scrollable');
					if(trigger.length > 0) {
						var IScroll = loadedSection.find('.fp-scrollable').data('iscrollInstance');
						IScroll.scrollTo(0, 0, 0);
					}
					
					animations.destroy_animations();
					if ($.isFunction(animations[anchorLink])) {
						animations[anchorLink]();
					}
					
					if($('.tour-section').length>0){
						setVisible();
					}					
				},

				onLeave: function(anchorLink, index, slideIndex, direction, nextSlideIndex) {				
					if(index>1){
						$('body').addClass('nav-scrolled');
					}else{
						$('body').removeClass('nav-scrolled');
					}
					var target = $($('#fullpage .section').get(index-1)).data('anchor');		
					$('.top-menu .nav-right .menu-item a').removeClass('active');
					$('.top-menu .nav-right .menu-item a[href="#'+target+'"]').addClass('active');
				},

				onSlideLeave: function(anchorLink, index, slideIndex, direction, nextSlideIndex) {
					animations.slides[anchorLink](slideIndex);
				},

				afterSlideLoad: function(anchorLink, index, slideAnchor, slideIndex) {
					if ($.isFunction(animations.slides[anchorLink])) {
						animations.slides[anchorLink](slideIndex);
					}
				}
			});
			
		}
	
	}, 200);	
});


$(function(){
	"use strict";
	
    $(document).on("click", ".slide-to", function(e) {
        e.preventDefault();
        $.fn.fullpage.moveTo($(this).attr('data-to'), 0);  
    });
    
	$(document).on("click", ".responsive-nav a", function(e) {
		
		$("body").removeClass('show-mobile-nav');
		//e.preventDefault();
    });
	
	
    animations.intro = function() {
		$("#intro_section video").get(0).play();
		$(".top-menu").addClass('visible');

		setTimeout(function() {
			$("#intro_section h1").addClass('visible');
				setTimeout(function() {
					$("#intro_section .description").addClass('visible');
				}, 500);
			}, 500);
    };
    	
    animations.about = function() {
       $("#about_section .animate").each(function(i, v) {
            setTimeout(function() {
                $(v).addClass('visible');
            }, i * 200);
        });
    };
    
    animations.what_we_do = function() {
        $("#markets_section .animate").each(function(i, v) {
            setTimeout(function() {
                $(v).addClass('visible');
            }, i * 200);
        });       
    };
    
	
    animations.contact = function() {
        $("#contact_section .animate").each(function(i, v) {
            setTimeout(function() {
                $(v).addClass('visible');
            }, i * 200);
        });
    };
    
    animations.destroy_animations = function() {
        $("#intro_section h1").removeClass('visible');
        $("#intro_section .description").removeClass('visible');
        $(".animate").removeClass('visible');        
    };
    
    animations.slides = {};
    
	callbacks();
});

function initShares(){
	"use strict";
	$('.close-share-this').click(function(){
		$('.modal.in').modal('hide');
		return false;
	});
	
	var clipboard = new Clipboard('.clipboardButton');
	clipboard.on('success', function(e) {
		console.info('Action:', e.action);
		console.info('Text:', e.text);
		console.info('Trigger:', e.trigger);
		
		$('.clipboardButton .copy-label').text(' copied!');
		
		e.clearSelection();
	});
	clipboard.on('error', function(e) {
		console.error('Action:', e.action);
		console.error('Trigger:', e.trigger);
		
	});		
}
function callbacks(c) {
	"use strict";
    var container = c || '';
    //ajaxContent(container + ' .ajax-content');

    $(container + ' .callbacks').each(function () {
        if(!$(this).hasClass('callbacks-executed')){
            if(container !=='' || !$(this).hasClass('callbacks-executed')){
                var c = $(this).data();
                for (var i in c) {
                    if (i.indexOf('fn') === 0 && c[i] !== '') {
                        var fn = c[i];
                        var params = c[ 'params' + i ] || null;

                        try {
                            if (c[ 'after' + i ] && typeof(window[c[ 'after' + i ]]) === 'function') {

                                var callbackAfter = c[ 'after' + i ];
                                var callbackAfterParams = c[ 'after' + i + 'Params' ] || null;

                                window[ fn ](params, function(){
                                    window[callbackAfter](callbackAfterParams);
                                });
                            } else {
                                window[ fn ](params);
                            }
							$(this).addClass('callbacks-executed');
                        } catch (Error) {
                            console.log(Error + ' '+fn);
                        }
                    }
                }
            }
        }
    });
}